export default "__VITE_ASSET__aWR7SgDX__"